import { signIn } from "src/utils/nextAuth";
import { AuthProvider } from "src/pages/api/auth/getUserTokenFromApi";

const guestLogin = async (): Promise<void> => {
  await signIn(AuthProvider.GUEST_LOGIN, {
    redirect: false,
  });
};

export { guestLogin };
